var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarTop = function SvgBarTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 8.333v10H6.508c-3.033 0-4.841-1.808-4.841-4.842V8.333z",
    opacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.333 6.509v1.825H1.667V6.509c0-3.034 1.808-4.842 4.841-4.842h6.984c3.033 0 4.841 1.808 4.841 4.842"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.333 8.333v5.158c0 3.034-1.808 4.842-4.841 4.842H10v-10z",
    opacity: 0.5
  })));
};
export default SvgBarTop;